import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import "./ConfigurationsRouter.component.scss";
import NewConfigurationPage from "../NewConfigurationPage/NewConfigurationPage.component";

class ConfigurationsRouter extends Component {
    render() {
        return (
            <div id="ConfigurationsRouter">
                <Route
                    render={({ location }) => (
                        <TransitionGroup>
                            <CSSTransition
                                key={location.key}
                                classNames="fade"
                                timeout={550}
                            >
                                <Switch location={location}>
                                    <Route
                                        path="/configurations/new/:hallId/:editingServer/:editingConfig?"
                                        component={NewConfigurationPage}
                                    />

                                    <Route
                                        path="/configurations/detail/:hallId/:editingServer/:editingConfig?"
                                        component={NewConfigurationPage}
                                    />

                                    <Route
                                        path="/configurations/upload/:uploadingServer"
                                        component={NewConfigurationPage}
                                    />

                                    <Route
                                        exact
                                        path="/configurations/"
                                        render={() => <Redirect to="/halls" />}
                                    />

                                    <Route
                                        exact
                                        path="/configurations/new/"
                                        render={() => <Redirect to="/halls" />}
                                    />
                                </Switch>
                            </CSSTransition>
                        </TransitionGroup>
                    )}
                />
            </div>
        );
    }
}

export default ConfigurationsRouter;
